<template>
	<div>
		<div class="center">
			<el-radio-group v-model="bodyView" size="small">
				<el-radio-button :label="1" title="Afficher le mannequin"><i class="fas fa-lg fa-male"></i></el-radio-button>
				<el-radio-button :label="0" title="Afficher le détail de toutes les zones inpactées"><i class="far fa-lg fa-list-alt"></i></el-radio-button>
			</el-radio-group>
		</div>
		<div class="divTable">
			
			<!-- Titre du sous menu -->
			<div v-bind:class="backgroundColor" class="divCellLeft hidden-xs-only">
				<div class="rotate">{{column.leftTitle}}</div>
			</div>
			<div class="divCellTop hidden-sm-and-up">
				<div v-bind:class="backgroundColor" class="border-r">{{column.leftTitle}}</div>
			</div>
			

			<!-- Dessin + zone texte -->
			<div class="divCell" >
				<el-row>
					<el-col :class="classicView">
						<table class="table">
							<tr>
								<!-- Dessin -->
								<td>
									<div v-on:click="changeView('front','back')" class="divfront principal">
										<DrawingWomanFront v-if="column.gender == 'F'" class="front" />
										<DrawingManFront v-else class="front" />
									</div>
									<div v-on:click="changeView('back','front')" class="divback second">
										<DrawingWomanBack v-if="column.gender == 'F'" class="back miniature" />
										<DrawingManBack v-else  class="back miniature" />
									</div>
								</td>
								<!-- Zone texte (md) -->
								<td class="width1 hidden-sm-and-down">
									<div class="body-detail ">
										Cliquez sur une zone pour afficher le détail
									</div>
									<div v-for="value in column.col01[0].child1" :key="value.value" :class="value.value" class="body-detail hidden"	>
										<checkup-detail v-bind="{checkupDetail:value}"/>
									</div>
								</td>
							</tr>
							<tr>
								<!-- Zone texte (sm et xs) -->
								<td class="hidden-md-and-up center">
									<div class="body-detail ">
										Cliquez sur une zone pour afficher le détail
									</div>
									<div v-for="value in column.col01[0].child1" :key="value.value" :class="value.value" class="body-detail hidden"	>
										<checkup-detail v-bind="{checkupDetail:value}"/>
									</div>
								</td>
							</tr>
						</table>
					</el-col>
						<el-col :md="8" :sm="24" :xs="24" v-for="value in column.col01[0].child1" :key="value.value" :class="listView" class="body-detail" >
								<checkup-detail v-bind="{checkupDetail:value}"/>
						</el-col>

				</el-row>
				<hr>
				<el-row>
					<el-col :md="8" :sm="24" :xs="24" v-for="value in column.col02" :key="value.id" >
						<checkup-detail v-bind:checkupDetail="value" />
					</el-col>
				</el-row>
			</div>
		</div>
  	</div>
</template>

<script>
	import CheckupDetail from "@/components/checkup.detail.component.vue";
	import DrawingManFront from "@/components/checkup.drawing.man.front.component.vue";
	import DrawingManBack from "@/components/checkup.drawing.man.back.component.vue";
	import DrawingWomanFront from "@/components/checkup.drawing.woman.front.component.vue";
	import DrawingWomanBack from "@/components/checkup.drawing.woman.back.component.vue";

	export default {
	name: "checkupTab",
	props: ["column", "parameters"],
	components: {
		CheckupDetail,
		DrawingManFront,
		DrawingManBack,
		DrawingWomanFront,
		DrawingWomanBack
	},

	computed: {
		backgroundColor() {
			return this.parameters.classColor;
		},
		backgroundColorTd() {
			return this.parameters.classColor + "-td";
		},
		borderL() {
			return this.parameters.borderLeft;
		},
		borderR() {
			return this.parameters.borderRight;
		},
		classicView() {
			return this.bodyView === 1 ? '' : 'hidden';
		},
		listView() {
			return this.bodyView === 0 ? '' : 'hidden';
		}
	},

	data() {
		return {
			bodyView : 1
		}
	},
	
	methods: {
		// Switch face / Dos
		changeView(on, off) {
		const selectorOn = this.$el.querySelector('.' + on);
		const selectorOff = this.$el.querySelector('.' + off);
		const selectorDivOn = this.$el.querySelector('.div' + on);
		const selectorDivOff = this.$el.querySelector('.div' + off);

		selectorOn.classList.remove('miniature');
		selectorOff.classList.add('miniature');

		selectorDivOn.classList.add('principal');
		selectorDivOn.classList.remove('second');

		selectorDivOff.classList.add('second');
		selectorDivOff.classList.remove('principal');
		}

	},

    mounted: function() {

		if(this.column.col01[0]){	
            this.column.col01[0].child1.forEach((item,index) => {
                this.$nextTick(() => { 
					// Toutes lesZones de texte
					const selectorAllTextArea = this.$el.querySelectorAll('.body-detail');
					// Nouvelle Zone de texte active
					const selectorAllNewTextArea = this.$el.querySelectorAll('.'+item.value);
					// Tout le corps (dessin)
					const selectorAllPath = this.$el.querySelectorAll('.a-body-area path');
					// Partie du corps traité
                    const selectorAreaPath = this.$el.querySelector(".a-body-area[data-area='"+item.value+"'] path");
                    // Zone des parties du corps traité
					const selectorArea = this.$el.querySelector(".a-body-area[data-area='"+item.value+"']");
					
					// On trafique le titre du super bloc pour avoir le nom de la partie du corps
					var frontOrBack = item.value.split('_');
					const selectorAllAreaName = this.$el.querySelectorAll('.area-name-'+item.value);
					selectorAllAreaName.forEach((t) => {t.innerHTML = ' '+selectorArea.dataset.nameArea + ' (' + frontOrBack[0] + ')';

					});

					// On colorie les zones impactées sur le corps
					selectorAreaPath.classList.add('fill');                                    
					
					// Click sur une zone de du corps
					//---------------------------------------------
					selectorArea.onclick = function() {						
						// On enlève la surbriallance de l'ancienne partie du corps active
						selectorAllPath.forEach((t) => {t.classList.remove('fillOn');});
						// On cache la zone texte de l'ancienne partie du corps active
						selectorAllTextArea.forEach((t) => {t.classList.add('hidden');});
						
						// on affiche la zone texte de la partie du corps active
						selectorAllNewTextArea.forEach((t) => {t.classList.remove('hidden');});
						// Surbrillance de la nouvelle partie du corps active	
						selectorAreaPath.classList.add('fillOn');  
					}
					//---------------------------------------------
				});
            });
        }   
	}
};
</script>

<style scoped>
.hidden {
  	display: none;
}
.width1 {
	width: 30%;
	text-align: center;
	vertical-align: middle;
}

.principal {
	width: 80%;
	display: inline-block;
}

.second {
  	width: 20%;
  	display: inline-block;
}

.miniature {
  	transform: scale(1.5) rotate(90deg) translate(-50%, 00%);
}


.center{
	text-align: center;
}

@media only screen and (max-width: 992px) {
  	.border-r {
		border-right-style: none;
		border-bottom-width: 6px;
		border-bottom-style: solid;
		border-color: white;
  	}
}

@media only screen and (max-width: 767px) {
	.border-l {
		border-left-style: none;
  	}
}
</style>

<style >
/* */
.fill{
  fill: #ff000073;
}

.fillOn{
    fill: #ff0000;
}
</style>
